// Primary 3 English Learning Data - Part 2 (Topics 11-18)
// Based on Primary English Learning P3 Topics.txt

export const p3DataPart2 = {
  topics: [
    {
      id: 'p3-topic-11',
      title: 'Telling the Dates',
      description: 'Learning to read and write dates in different formats',
      purpose: 'To teach students how to read, write, and understand dates in various formats including ordinal numbers.',
      questions: [
        {
          question: 'What date is January 1st?',
          answer: 'first',
          explanation: 'Use "first" for the 1st day of the month.'
        },
        {
          question: 'What date is February 2nd?',
          answer: 'second',
          explanation: 'Use "second" for the 2nd day of the month.'
        },
        {
          question: 'What date is March 3rd?',
          answer: 'third',
          explanation: 'Use "third" for the 3rd day of the month.'
        },
        {
          question: 'What date is April 4th?',
          answer: 'fourth',
          explanation: 'Use "fourth" for the 4th day of the month.'
        },
        {
          question: 'What date is May 5th?',
          answer: 'fifth',
          explanation: 'Use "fifth" for the 5th day of the month.'
        },
        {
          question: 'What date is June 6th?',
          answer: 'sixth',
          explanation: 'Use "sixth" for the 6th day of the month.'
        },
        {
          question: 'What date is July 7th?',
          answer: 'seventh',
          explanation: 'Use "seventh" for the 7th day of the month.'
        },
        {
          question: 'What date is August 8th?',
          answer: 'eighth',
          explanation: 'Use "eighth" for the 8th day of the month.'
        },
        {
          question: 'What date is September 9th?',
          answer: 'ninth',
          explanation: 'Use "ninth" for the 9th day of the month.'
        },
        {
          question: 'What date is October 10th?',
          answer: 'tenth',
          explanation: 'Use "tenth" for the 10th day of the month.'
        }
      ]
    },
    {
      id: 'p3-topic-12',
      title: 'Sequence Markers',
      description: 'Learning to use sequence markers (first, then, next, finally) to organize ideas',
      purpose: 'To teach students how to use sequence markers to organize ideas and show the order of events or steps.',
      questions: [
        {
          question: 'Complete: "_____ I wake up, then I brush my teeth."',
          answer: 'First',
          explanation: 'Use "First" to indicate the beginning of a sequence.'
        },
        {
          question: 'Fill in the blank: "First I wake up, _____ I brush my teeth."',
          answer: 'then',
          explanation: 'Use "then" to show the next step in a sequence.'
        },
        {
          question: 'Complete: "Then I eat breakfast, _____ I go to school."',
          answer: 'next',
          explanation: 'Use "next" to show the following step in a sequence.'
        },
        {
          question: 'Fill in the blank: "Next I go to school, _____ I come home."',
          answer: 'finally',
          explanation: 'Use "finally" to show the last step in a sequence.'
        },
        {
          question: 'Complete: "_____ I put on my shoes, then I go outside."',
          answer: 'First',
          explanation: 'Use "First" to indicate the beginning of a sequence.'
        },
        {
          question: 'Fill in the blank: "First I study, _____ I play games."',
          answer: 'then',
          explanation: 'Use "then" to show the next step in a sequence.'
        },
        {
          question: 'Complete: "Then I play games, _____ I go to bed."',
          answer: 'finally',
          explanation: 'Use "finally" to show the last step in a sequence.'
        },
        {
          question: 'Fill in the blank: "First I wash my hands, _____ I eat."',
          answer: 'then',
          explanation: 'Use "then" to show the next step in a sequence.'
        },
        {
          question: 'Complete: "Then I eat, _____ I wash the dishes."',
          answer: 'next',
          explanation: 'Use "next" to show the following step in a sequence.'
        },
        {
          question: 'Fill in the blank: "Next I wash the dishes, _____ I watch TV."',
          answer: 'finally',
          explanation: 'Use "finally" to show the last step in a sequence.'
        }
      ]
    },
    {
      id: 'p3-topic-13',
      title: 'Modal Verbs',
      description: 'Learning to use modal verbs (can, could, may, might, must, should) to express different meanings',
      purpose: 'To teach students how to use modal verbs to express ability, permission, possibility, obligation, and advice.',
      questions: [
        {
          question: 'I _____ swim very well.',
          answer: 'can',
          explanation: 'Use "can" to express ability.'
        },
        {
          question: '_____ I borrow your pen?',
          answer: 'May',
          explanation: 'Use "may" to ask for permission politely.'
        },
        {
          question: 'You _____ study hard for the exam.',
          answer: 'should',
          explanation: 'Use "should" to give advice or make recommendations.'
        },
        {
          question: 'She _____ speak three languages.',
          answer: 'can',
          explanation: 'Use "can" to express ability.'
        },
        {
          question: 'You _____ wear a helmet when cycling.',
          answer: 'must',
          explanation: 'Use "must" to express strong obligation or necessity.'
        },
        {
          question: 'It _____ rain tomorrow.',
          answer: 'might',
          explanation: 'Use "might" to express possibility.'
        },
        {
          question: '_____ I go to the bathroom?',
          answer: 'May',
          explanation: 'Use "may" to ask for permission politely.'
        },
        {
          question: 'You _____ eat more vegetables.',
          answer: 'should',
          explanation: 'Use "should" to give advice about healthy eating.'
        },
        {
          question: 'He _____ play the piano beautifully.',
          answer: 'can',
          explanation: 'Use "can" to express ability.'
        },
        {
          question: 'You _____ be quiet in the library.',
          answer: 'must',
          explanation: 'Use "must" to express strong obligation.'
        }
      ]
    },
    {
      id: 'p3-topic-14',
      title: 'Adverbs of Degree',
      description: 'Learning to use adverbs of degree (very, quite, rather, extremely, slightly)',
      purpose: 'To teach students how to use adverbs of degree to modify adjectives and other adverbs to show intensity.',
      questions: [
        {
          question: 'I am _____ happy.',
          answer: 'very',
          explanation: 'Use "very" to emphasize the degree of happiness.'
        },
        {
          question: 'She is _____ tired.',
          answer: 'quite',
          explanation: 'Use "quite" to show a moderate degree.'
        },
        {
          question: 'He is _____ tall.',
          answer: 'very',
          explanation: 'Use "very" to emphasize the degree of height.'
        },
        {
          question: 'They are _____ busy.',
          answer: 'very',
          explanation: 'Use "very" to emphasize the degree of being busy.'
        },
        {
          question: 'The weather is _____ cold.',
          answer: 'quite',
          explanation: 'Use "quite" to show a moderate degree.'
        },
        {
          question: 'I am _____ hungry.',
          answer: 'very',
          explanation: 'Use "very" to emphasize the degree of hunger.'
        },
        {
          question: 'She is _____ beautiful.',
          answer: 'very',
          explanation: 'Use "very" to emphasize the degree of beauty.'
        },
        {
          question: 'He is _____ smart.',
          answer: 'very',
          explanation: 'Use "very" to emphasize the degree of intelligence.'
        },
        {
          question: 'The food is _____ delicious.',
          answer: 'very',
          explanation: 'Use "very" to emphasize the degree of taste.'
        },
        {
          question: 'I am _____ excited.',
          answer: 'very',
          explanation: 'Use "very" to emphasize the degree of excitement.'
        }
      ]
    },
    {
      id: 'p3-topic-15',
      title: 'Phrasal Verbs',
      description: 'Learning to use phrasal verbs (verb + preposition/adverb)',
      purpose: 'To teach students how to use phrasal verbs which consist of a verb and a preposition or adverb to create new meanings.',
      questions: [
        {
          question: 'I _____ my coat before entering.',
          answer: 'take off',
          explanation: 'Use "take off" to mean remove clothing.'
        },
        {
          question: 'She _____ her shoes at the door.',
          answer: 'takes off',
          explanation: 'Use "take off" to mean remove clothing.'
        },
        {
          question: 'I _____ my homework before dinner.',
          answer: 'finish up',
          explanation: 'Use "finish up" to mean complete something.'
        },
        {
          question: 'He _____ his room every day.',
          answer: 'cleans up',
          explanation: 'Use "clean up" to mean tidy or organize.'
        },
        {
          question: 'We _____ the toys after playing.',
          answer: 'put away',
          explanation: 'Use "put away" to mean store or organize.'
        },
        {
          question: 'I _____ my book before sleeping.',
          answer: 'put down',
          explanation: 'Use "put down" to mean place something on a surface.'
        },
        {
          question: 'She _____ her bag on the table.',
          answer: 'puts down',
          explanation: 'Use "put down" to mean place something on a surface.'
        },
        {
          question: 'I _____ my keys in my pocket.',
          answer: 'put away',
          explanation: 'Use "put away" to mean store or organize.'
        },
        {
          question: 'He _____ his homework quickly.',
          answer: 'finishes up',
          explanation: 'Use "finish up" to mean complete something.'
        },
        {
          question: 'We _____ the dishes after eating.',
          answer: 'wash up',
          explanation: 'Use "wash up" to mean clean dishes or hands.'
        }
      ]
    },
    {
      id: 'p3-topic-16',
      title: 'To Infinitives',
      description: 'Learning to use to-infinitives (to + base form of verb) in different contexts',
      purpose: 'To teach students how to use to-infinitives to express purpose, intention, or as part of verb patterns.',
      questions: [
        {
          question: 'I want _____ (go) to the park.',
          answer: 'to go',
          explanation: 'Use "to + base form" after "want".'
        },
        {
          question: 'She likes _____ (read) books.',
          answer: 'to read',
          explanation: 'Use "to + base form" after "likes".'
        },
        {
          question: 'I need _____ (buy) some food.',
          answer: 'to buy',
          explanation: 'Use "to + base form" after "need".'
        },
        {
          question: 'He wants _____ (play) football.',
          answer: 'to play',
          explanation: 'Use "to + base form" after "wants".'
        },
        {
          question: 'We like _____ (watch) movies.',
          answer: 'to watch',
          explanation: 'Use "to + base form" after "like".'
        },
        {
          question: 'I want _____ (learn) English.',
          answer: 'to learn',
          explanation: 'Use "to + base form" after "want".'
        },
        {
          question: 'She needs _____ (study) hard.',
          answer: 'to study',
          explanation: 'Use "to + base form" after "needs".'
        },
        {
          question: 'He likes _____ (sing) songs.',
          answer: 'to sing',
          explanation: 'Use "to + base form" after "likes".'
        },
        {
          question: 'I want _____ (visit) my grandmother.',
          answer: 'to visit',
          explanation: 'Use "to + base form" after "want".'
        },
        {
          question: 'We need _____ (clean) the house.',
          answer: 'to clean',
          explanation: 'Use "to + base form" after "need".'
        }
      ]
    },
    {
      id: 'p3-topic-17',
      title: 'Sentence Structure',
      description: 'Learning to construct different types of sentences with more complexity',
      purpose: 'To teach students how to construct different types of sentences with proper word order and structure, including compound and complex sentences.',
      questions: [
        {
          question: 'Complete: "I _____ a student."',
          answer: 'am',
          explanation: 'Use the correct form of "to be" for the subject "I".'
        },
        {
          question: 'Fill in the blank: "She _____ English."',
          answer: 'speaks',
          explanation: 'Use the correct verb form for third person singular.'
        },
        {
          question: 'Complete: "_____ you like ice cream?"',
          answer: 'Do',
          explanation: 'Use "Do" to form questions with "you".'
        },
        {
          question: 'Fill in the blank: "_____ is your name?"',
          answer: 'What',
          explanation: 'Use "What" to ask about things or names.'
        },
        {
          question: 'Complete: "_____ the door."',
          answer: 'Open',
          explanation: 'Use the base form of the verb for imperatives.'
        },
        {
          question: 'Fill in the blank: "They _____ football."',
          answer: 'play',
          explanation: 'Use the base form of the verb for plural subjects.'
        },
        {
          question: 'Complete: "_____ do you live?"',
          answer: 'Where',
          explanation: 'Use "Where" to ask about location.'
        },
        {
          question: 'Fill in the blank: "He _____ in Hong Kong."',
          answer: 'lives',
          explanation: 'Use the correct verb form for third person singular.'
        },
        {
          question: 'Complete: "_____ your homework."',
          answer: 'Do',
          explanation: 'Use the base form of the verb for imperatives.'
        },
        {
          question: 'Fill in the blank: "We _____ to school."',
          answer: 'go',
          explanation: 'Use the base form of the verb for "we".'
        }
      ]
    },
    {
      id: 'p3-topic-18',
      title: 'Articles',
      description: 'Learning to use articles (a, an, the) correctly in more complex sentences',
      purpose: 'To teach students how to use definite and indefinite articles to specify or generalize nouns in more complex contexts.',
      questions: [
        {
          question: 'I have _____ apple.',
          answer: 'an',
          explanation: 'Use "an" before words that begin with vowel sounds (a, e, i, o, u).'
        },
        {
          question: '_____ sun is bright.',
          answer: 'The',
          explanation: 'Use "the" when referring to a specific, unique thing.'
        },
        {
          question: 'I see _____ cat.',
          answer: 'a',
          explanation: 'Use "a" before words that begin with consonant sounds.'
        },
        {
          question: '_____ moon is beautiful.',
          answer: 'The',
          explanation: 'Use "the" when referring to a specific, unique thing.'
        },
        {
          question: 'I have _____ orange.',
          answer: 'an',
          explanation: 'Use "an" before words that begin with vowel sounds.'
        },
        {
          question: '_____ book is on the table.',
          answer: 'The',
          explanation: 'Use "the" when referring to a specific book.'
        },
        {
          question: 'I want _____ banana.',
          answer: 'a',
          explanation: 'Use "a" before words that begin with consonant sounds.'
        },
        {
          question: '_____ earth is round.',
          answer: 'The',
          explanation: 'Use "the" when referring to a specific, unique thing.'
        },
        {
          question: 'I have _____ umbrella.',
          answer: 'an',
          explanation: 'Use "an" before words that begin with vowel sounds.'
        },
        {
          question: '_____ dog is running.',
          answer: 'The',
          explanation: 'Use "the" when referring to a specific dog.'
        }
      ]
    }
  ]
}; 